import React from 'react'
import { useWindowDimensions, ScrollView, View, Image, Linking } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'
import RenderHtml from 'react-native-render-html'
import { useMediaQuery } from 'react-responsive'

const source1 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>As trilhas formativas serão oferecidas após diagnóstico realizado junto à empresa. Por meio de entrevistas, o consultor irá levantar as necessidades e gaps de competências e habilidades da empresa atendida. O diagnóstico será acompanhado de plano de ação em capacitação, que poderá conter uma ou mais trilhas formativas sob medida.</p>
`
};

export default function Capacitacao() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height

  const _goForm = () => {
    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSfaHF7_NdRS90Mja7B2W7PGYnTvcRYdubOtNyJfP5ZyjwvJXg/viewform?vc=0&c=0&w=1&flr=0')
  }

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="CAPACITAÇÃO SOB MEDIDA" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
              <View style={{marginTop: isLargeScreen ? 40 : 120}}>
                <Image source={require('../assets/images/programa_sobmedida.svg')} style={{width: windowWidth-450, height: isLargeScreen ? 220 : 180, alignSelf: isLargeScreen ? 'flex-start' : 'center'}} resizeMode="cover" />
              </View>
              <View style={tailwind('mt-10')}>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>DETALHAMENTO DO PROGRAMA</Text>
                <View style={tailwind('mx-5 mb-10')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
